/*
 * Copyright (c) 2008-2021 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
 * This is CONFIDENTIAL code. Use is subject to license terms.
 */
/*eslint-env node*/

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue"

import "bootstrap/dist/js/bootstrap.min.js"

import "./utils/vue-fontawesome"
import { FontAwesomeIcon, FontAwesomeLayers } from "@fortawesome/vue-fontawesome"

// Register font awesome components globally to avoid import statements in components
Vue.component("icon", FontAwesomeIcon)
Vue.component("icon-layers", FontAwesomeLayers)

import VueClipboard from "vue-clipboard2"

Vue.use(VueClipboard)

import ToggleButton from "vue-js-toggle-button"

Vue.use(ToggleButton)

import VueResource from "vue-resource"

Vue.use(VueResource)

import vSelect from "vue-select"
Vue.component("v-select", vSelect)
import "vue-select/dist/vue-select.css"

// Date picker (https://github.com/mariomka/vue-datetime)
import Datetime from "vue-datetime"
import "vue-datetime/dist/vue-datetime.css"
Vue.use(Datetime)

import fullscreen from "vue-fullscreen"
Vue.use(fullscreen)
// noinspection ES6UnusedImports
import { EventBus } from "~/common/src/event-bus" // eslint-disable-line no-unused-vars
// log and EventBus define global vars required by communication - which is loaded by the router / store ..... (legacy ...)
// log is required to be loaded before ServerCommunication!
// noinspection ES6UnusedImports
import { log } from "~/common/src/utils/log" // eslint-disable-line no-unused-vars
import App from "./App"
import "./assets/scss_custom/main.scss"
import { registerInterceptor } from "./auth/OAuth2AuthorizationCode"

import setupCommunicationWithRouter from "./communication"
import i18n from "./i18n"
import router from "./router"
import store from "./store"
import { login, mixin as oauth2AuthorizationCodeMixin } from "@/auth/OAuth2AuthorizationCode"
import WindowResizeMixin from "./utils/WindowResizeMixin"

// Necessary for permissions to be loaded
import "./auth/authorization"

import Vuelidate from "vuelidate"
Vue.use(Vuelidate)

import "vue-full-screen-file-drop/dist/vue-full-screen-file-drop.css"

import he from "he"
Object.defineProperty(Vue.prototype, "$he", { value: he })

// handle start / stop of server connection
setupCommunicationWithRouter(router)

Vue.config.productionTip = false

// Register a global custom directive called `v-focus`
Vue.directive("focus", {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    el.setSelectionRange(0, el.value.length)
    el.focus()
  },
})

// As we use bootstrap jquery is available anyway - we need jquery e.g. for opening modals programmatically
let jquery = require("jquery")
// Bind before the app is created to allow for use in mount properties
Object.defineProperty(Vue.prototype, "$$", { value: jquery })

// Bootstrap tooltips as v-tooltip directive on any element
// Stolen from https://stackoverflow.com/a/52327358/5515410
// See also https://gist.github.com/victornpb/020d393f2f5b866437d13d49a4695b47
const bsTooltip = (el, binding) => {
  // Dispose the previous one, otherwise a locale change will have no effect
  jquery(el).tooltip("dispose")

  if (binding.arg === "none") {
    return
  }

  const t = []

  if (binding.modifiers.focus) t.push("focus")
  if (binding.modifiers.hover) t.push("hover")
  if (binding.modifiers.click) t.push("click")
  if (!t.length) t.push("hover")

  jquery(el).tooltip({
    title: binding.value,
    container: "#app", // Necessary for correct display, see https://stackoverflow.com/q/41602487/5515410
    placement: binding.arg || "top",
    trigger: t.join(" "),
    html: !!binding.modifiers.html,
    delay: { show: 500, hide: 100 },
    boundary: "window",
  })
}

Vue.directive("tooltip", {
  bind: bsTooltip,
  update: bsTooltip,
  unbind(el) {
    jquery(el).tooltip("dispose")
  },
})

require("@/assets/js/date.js") // Simplifies date formatting and parsing (from http://javascripttoolbox.com/lib/date/index.php)

registerInterceptor()
// retrieve access token before init of vue instance
login().then(() => {
  new Vue({
    el: "#mainApp",
    router,
    i18n,
    store,
    components: {
      App,
    },
    /*mixins: [PluginManager],*/
    mixins: [oauth2AuthorizationCodeMixin, WindowResizeMixin],
    template: "<App/>",
  })
})
